import styled, { css } from 'styled-components';
import { COLOURS, FONT_WEIGHT, getBodyFont, getHeadingFont, SPACES } from '@belong/themes';
import { ITableV2Props } from './TableV2.types';

export const TableViewportScroller = styled.div.attrs({ tabIndex: 0 })`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const TableStyled = styled.table<Pick<ITableV2Props, 'textAlign' | 'striped'>>`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-color: ${COLOURS.GREY_500};

  caption {
    ${getHeadingFont('medium')}

    text-align: left;
    font-weight: ${FONT_WEIGHT.BOLD};
    color: ${COLOURS.GREY_700};
    padding: ${SPACES.xsmall}rem 0;
  }

  td,
  th {
    text-align: ${({ textAlign }) => textAlign};
    min-width: 20rem;
    height: 5.6rem;
    padding: ${SPACES.xsmall}rem ${SPACES.small}rem;
    ${getBodyFont('small')};
  }

  td {
    color: ${COLOURS.GREY_600};
  }

  th {
    background: ${COLOURS.GREY_200};
    color: ${COLOURS.GREY_700};
    font-weight: ${FONT_WEIGHT.SEMI_BOLD};
  }

  thead + tbody tr:first-child td {
    border-top: solid 4px;
  }

  tbody {
    th + td {
      border-left: solid 4px;
    }

    td {
      border-bottom: solid 1px;
    }

    th {
      /* So we get a border on forced-css we set this to the same colour as the background */
      border-bottom: solid 1px ${COLOURS.GREY_200};
    }

    tr:last-child th {
      border-bottom: solid 1px;
    }
  }

  ${({ striped }) =>
    striped &&
    css`
      tbody tr:nth-child(even) td {
        background-color: ${COLOURS.GREY_100};
      }
    `}
`;
